import React from 'react';
import { OfflineDialog } from 'app/components/Offline/OfflineDialog';
import { useOnlineStatus } from './hooks';

const INFO_TEXT =
  'Seems like you’re offline, please check your internet connection';

export const OfflineTracker: React.FC = () => {
  const { isOnline } = useOnlineStatus();

  if (isOnline) {
    return null;
  }

  return <OfflineDialog subtitle="No Internet Connection" text={INFO_TEXT} />;
};
